(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-ingredient-page-drawers]').forEach((host) => {
      if (host.dataset.ready) return;
      host.dataset.ready = 'true';
      const section = document.getElementById(host.dataset.pageSection);
      const controller = new window.GarrnishIngredientFocus(host);
      section.querySelectorAll('[data-ingredient-page-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => controller.openDialog(trigger));
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
